module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-600.woff?4059e93e46bbb24b5cb6ffd1d0dc7ae2";